import React, { useEffect, useState } from 'react';
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import { Grid, Paper, Typography } from '@mui/material';
import FolderSkyIcon from "../../../../src/assets/img/FolderSkyIcon.svg";
import { globalGetService } from '../../../utils/globalApiServices';
import { getSystemDocumentApi } from '../apiService';
import { useNavigate, useParams } from 'react-router-dom';
import { checkApiStatus } from '../../../utils';
import { PageLoader, STableLoader } from '../../../shared_elements';
import { isMobile } from 'react-device-detect';
import { trackActivity } from '../../../utils/mixpanel';
import { useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { isSubFolders } from '../config';


const SystemDocuments = () => {
    const navigate = useNavigate();
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [systemDocumentsData, setSystemDocumentsData] = useState([]);
    const { leaseBasicDetails } = useSelector((state) => state.leases);

    useEffect(() => {
        trackActivity('Page Viewed',{ page_title: 'System Documents'})
    }, [])
    useEffect(() => {
        if (!leaseBasicDetails?.status) return;
        getSystemDocuments("skeletonLoader");
    }, [leaseBasicDetails?.status]);

    const getSystemDocuments = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getSystemDocumentApi(params, query), {})
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus) {
                    setSystemDocumentsData(response?.data?.data);
                }
            })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                    <div className='lease-details-content'>
                    <Paper square className="responsive-paper">
                        <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                            <Grid item md={4} xs={12} className="menu-container lease-list-link-mt">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item md={8} xs={12}></Grid>
                        </Grid>
                    </Paper>
                    {skeletonLoader ? ( <PageLoader count={7} /> ) : systemDocumentsData.length > 0 ? (
                        <div className='lease-detail-table'>
                            <div className='tab-detail-container'>
                                <Grid container spacing={isMobile ? 3 : 5}>
                                    {
                                        systemDocumentsData.map((item) => (
                                            <Grid size={{ md: 2, xs: 4 }}>
                                                <div style={{ justifySelf: "anchor-center", cursor: 'pointer' }}
                                                    onClick={() => {
                                                        const path = isSubFolders(item?.module_name)
                                                            ? `/lease/${params.leaseSlug}/system-document/${item?.module_name}/assemblies`
                                                            : `/lease/${params.leaseSlug}/system-document/${item?.module_name}`;
                                                        navigate(path, { state: { displayName: item?.display_name } });
                                                        trackActivity('Item Clicked', { page_title: 'System Documents', page_type: `Clicked on Folder Icon (${item?.module_name})` });
                                                    }}>
                                                    <img src={FolderSkyIcon} alt="FolderSkyIcon" />
                                                </div>
                                                <div style={{ justifySelf: "anchor-center" }}>
                                                    <Typography className='system-doc-title' variant='h7'>{item.display_name} <span>({item.file_count})</span></Typography>
                                                </div>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </div>
                        </div>
                    ) : <Typography className='no-record-found'>No Record Found</Typography>}
                    </div>}
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default SystemDocuments;